import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { FiltersFormTerritorialArea } from './types';
import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { TerritorialArea } from 'shell/models/territorial-area';
import { TerritorialAreaClient } from 'shell/view-models/territorial-area-client';

export const transformDataset = (values?: FiltersFormTerritorialArea): string => {
  const { ...otherValues } = values;

  let transformedFilters: Partial<OperationObject> = {
    codiceVia: {
      value: otherValues.streetName?.code || '',
      operation: Operation.EQUALS,
    },
    civicoDa: {
      value: otherValues.civicNumberFrom || '',
      operation: Operation.EQUALS,
    },
    civicoA: {
      value: otherValues.civicNumberTo || '',
      operation: Operation.EQUALS,
    },
    esponenteDa: {
      value: otherValues.exponentFrom || '',
      operation: Operation.EQUALS,
    },
    esponenteA: {
      value: otherValues.exponentTo || '',
      operation: Operation.EQUALS,
    },
  };

  if (otherValues.civicType === 'even') {
    transformedFilters = {
      ...transformedFilters,
      civiciPari: {
        value: true,
        operation: Operation.EQUALS,
      },
    };
  }

  if (otherValues.civicType === 'odd') {
    transformedFilters = {
      ...transformedFilters,
      civiciDispari: {
        value: true,
        operation: Operation.EQUALS,
      },
    };
  }

  return `${paginationListToQueryString({
    filters: transformedFilters as OperationObject,
    orders: {},
  })}`;
};

export const transformerList = (
  response: AxiosResponse<HttpResponseList<TerritorialArea>>
): Array<TerritorialAreaClient> => {
  const list = response.data.payload.list || [];

  return list.map(
    (item) =>
      ({
        streetCode: item.key.codice || '',
        civicNumber: item.key.numero || '',
        exponent: item.key.esponente?.trim() || '',
        territorialArea: item.ambitoTerritoriale || '',
        totalRows: response.data.payload.totalRows || 0,
        municipality: item.municipio || '',
        block: item.isolato || '',
        censusSection: item.sezCensim || '',
        zipCode: item.cap || '',
        hidden: {
          read: false,
          edit: false,
          delete: false,
        },
      } as TerritorialAreaClient)
  );
};
